//React
import React from 'react';
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


//Material-ui
import Button from '@material-ui/core/Button';

//Part
import PartPageTitle from './PartPageTitle';



class Comp extends React.Component {



  componentDidMount() {
    document.title = this.props.title + ' - パートナーズ';
    window.scrollTo(0, 0);
  }


  render() {
    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={this.props.title}
        />

        <div align='center' style={{margin:'15px'}}>
          サービス停止中はご利用いただけません
        </div>
        <div align='center' style={{margin:'15px'}}>
          <Link to={'/setting/stop/'}>
            <Button
              color="primary"
              variant={ "outlined" }
            >
              サービスの停止を解除する
            </Button>
          </Link>
        </div>


      </div>

    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
